'use client';
import { ArrowDownIcon, ArrowUpIcon } from '@/components/icons/svg-icons';
import { styles } from './collapse-all-league.style';
import { useTranslations } from 'next-intl';

export interface CollapseAllLeagueProps {
	isAllLeagueExpand: boolean;
	clickAllLeague: () => void;
}
export const CollapseAllLeague = ({ isAllLeagueExpand, clickAllLeague }: CollapseAllLeagueProps) => {
	const t = useTranslations('General');

	return (
		<div className={styles.container} onClick={clickAllLeague}>
			<div className={styles.text}>
				{isAllLeagueExpand ? t('lbl_CollapseAllLeagues') : t('lbl_ExpandAllLeagues')}
			</div>
			{isAllLeagueExpand ? <ArrowUpIcon /> : <ArrowDownIcon />}
		</div>
	)
}